"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssuesEntityBlock = void 0;
var _react = _interopRequireDefault(require("react"));
var _IssuesConsumer = require("../IssuesConsumer");
var _Stamp = require("../utils/components/Stamp");
var _accReferencePicker = require("@adsk/acc-reference-picker");
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _alloyReactTooltip = require("@adsk/alloy-react-tooltip");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("./helpers/utils");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
const removeButtonClassName = "IssueEntityBlock__remove-button";
const EntityBlockContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  height: 68px;\n  padding: 10px 14px 10px 10px;\n  display: grid;\n  grid-template: \"stamp title remove\" 27px \"stamp details remove\" auto / 62px auto 30px;\n  &:hover .", " {\n    visibility: visible;\n  }\n"])), removeButtonClassName);
const IssuesEntityBlock = exports.IssuesEntityBlock = (0, _IssuesConsumer.withIssuesConsumer)(_ref => {
  let {
    projectId,
    entity: issue,
    onRemoveClick,
    onReferenceClickAnalytics
  } = _ref;
  const assigneeName = (0, _utils.useAssigneeName)(issue);
  const issueLabel = "#".concat(issue.displayId, " - ").concat(issue.title);
  const issueTypeCode = (0, _utils.useIssueTypeCode)(issue.issueTypeId);
  return /*#__PURE__*/_react.default.createElement(EntityBlockContainer, {
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      onReferenceClickAnalytics && onReferenceClickAnalytics();
      window.open((0, _utils.getIssueUrl)({
        projectId,
        issueId: issue.id
      }));
    }
  }, /*#__PURE__*/_react.default.createElement(_Stamp.Stamp, {
    size: 48,
    text: issueTypeCode,
    status: issue.status
  }), /*#__PURE__*/_react.default.createElement(_alloyReactTooltip.OverflowTooltip, {
    content: issueLabel,
    singleLine: true,
    getTargetProps: () => ({
      style: {
        overflow: "hidden",
        gridArea: "title"
      }
    })
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: _alloyReactTheme.default.typography.bodyMediumBold
  }, issueLabel)), /*#__PURE__*/_react.default.createElement(_alloyReactTooltip.OverflowTooltip, {
    content: assigneeName,
    singleLine: true,
    getTargetProps: () => ({
      style: {
        gridArea: "details",
        whiteSpace: "nowrap",
        overflow: "hidden"
      }
    })
  }, assigneeName), onRemoveClick && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      alignSelf: "center",
      justifySelf: "end",
      gridArea: "remove"
    }
  }, /*#__PURE__*/_react.default.createElement(_accReferencePicker.BlockRemoveButton, {
    className: removeButtonClassName,
    style: {
      visibility: "hidden"
    },
    onClick: onRemoveClick
  })));
});
//# sourceMappingURL=IssuesEntityBlock.js.map